import LayoutInfoHeaderLeft from "./LayoutInfoHeaderLeft";
import LayoutInfoHeaderRight from "./LayoutInfoHeaderRight";
import LayoutInfoBodyRight from "./LayoutInfoBodyRight";
import LayoutInfoBodyLeft from "./LayoutInfoBodyLeft";
import LayoutInfoHeader from "./LayoutInfoHeader";
import LayoutInfoBody from "./LayoutInfoBody";
import LayoutInfoRoot from "./LayoutInfoRoot";

export const LayoutInfo = {
    Root: LayoutInfoRoot,
    Body: LayoutInfoBody,
    Header: LayoutInfoHeader,
    HeaderLeft: LayoutInfoHeaderLeft,
    HeaderRight: LayoutInfoHeaderRight,
    BodyLeft: LayoutInfoBodyLeft,
    BodyRight: LayoutInfoBodyRight,
};
